import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from '@app/state/app.state';
import { Subscription } from 'rxjs';
import { UserRole, UtilityHubIdentity } from '@auth/models/utility-hub-identity';
import { selectLoggedInUser, selectLoggedInUtilityHubIdentity } from '@auth/state/selectors/auth.selectors';
import { loggedInUserSelector, loggedInUtilityHubIdentitySelector } from '@app/state/app.selectors';

@Component({
  selector: 'app-share-quote-configuration',
  templateUrl: './share-quote-configuration.component.html',
  styleUrls: ['./share-quote-configuration.component.scss']
})
export class ShareQuoteConfigurationComponent implements OnInit, OnDestroy {
  @Input() formGroupName: string;
  configurationForm: FormGroup;
  allcheck: boolean = false;
  somecheck: boolean = false;
  displaySupplierProperty : boolean = false; // Always is false because is part to broker360 feature
  checkcount: number;
  valuelenght: number;
  formSubscription$: Subscription;
  selectLoggedInUser$: Subscription;
  uhIdentity$: Subscription;
  userIdentity: UtilityHubIdentity;
  constructor(private rootFormGroup: FormGroupDirective,  private store: Store<AppState>,) {

  }
  ngOnDestroy(): void {
    this.formSubscription$?.unsubscribe();
    this.selectLoggedInUser$?.unsubscribe();
    this.uhIdentity$?.unsubscribe();
  }

  setAll(value) {
    this.allcheck = value;
    this.configurationForm.patchValue({
      productType: value,
      supplier: value,
      annualCommission: this.isSupplierOrSupplierManagerOrSalesManager() ? value : false,
      totalCommission: this.isSupplierOrSupplierManagerOrSalesManager() ? value : false,
      totalCost:value,
      annualCost :value,
      usage: value,
    });
  }

  ngOnInit(): void {
    this.configurationForm = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
    this.formSubscription$ = this.configurationForm.valueChanges.subscribe(value => this.getCheckboxState(value, this));

    this.selectLoggedInUser$ = this.store.select(loggedInUserSelector).subscribe((user) => {
      if (user && !user.expired) {
        this.uhIdentity$ = this.store.select(loggedInUtilityHubIdentitySelector).subscribe((uhUser) => {
          this.userIdentity = uhUser;
        });
      }
    });
    this.isSupplierOrSupplierManagerOrSalesManager();
  }

  isSupplierOrSupplierManagerOrSalesManager() : boolean {
    return this.userIdentity.isSupplierManagerOrSalesManager ||
    this.userIdentity.currentOrganisation.role == UserRole.Supplier
  }

  getCheckboxState(value, self) {

    this.checkcount = 0;
    this.valuelenght = 0;

    for (let item in value) {
      if (value[item] == true) {
        this.checkcount++;
      }
      this.valuelenght++;
    }

    if (this.checkcount == 0 || this.checkcount == this.valuelenght) {
      this.somecheck = false;
      if (this.checkcount == 0) {
        this.allcheck = false;
      }
      else {
        this.allcheck = true;
      }
    }
    else {
      this.somecheck = true;
    }
  }

  isValid() {
    let checkList = this.configurationForm.get("configuration").value;
    return Object.values(checkList.value).some(_ => _ == true);
  }

}
